export enum DisabledFeature {
    publish = 'publish',
    newFolder = 'newFolder',
    newFile = 'newFile',
    createAlbum = 'createAlbum',
}
